// CSV pentru Excel in romana: separatorul `;`, BOM UTF-8 (diacriticele), numere cu virgula.

export interface Column<T> {
  label: string;
  value: (row: T) => string | number | null | undefined;
}

function cell(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return '';
  const s = typeof v === 'number' ? String(v).replace('.', ',') : v;
  return /[";\n\r]/.test(s) || /^[=+\-@]/.test(s)
    ? `"${s.replace(/"/g, '""').replace(/^([=+\-@])/, "'$1")}"`
    : s;
}

export function toCsv<T>(rows: readonly T[], columns: readonly Column<T>[]): string {
  const lines = [columns.map((c) => cell(c.label)).join(';')];
  for (const r of rows) lines.push(columns.map((c) => cell(c.value(r))).join(';'));
  return `﻿${lines.join('\r\n')}\r\n`;
}

export function download(name: string, content: string, type = 'text/csv;charset=utf-8'): void {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
